import React, { useEffect, useState } from 'react'
import './style.sass'
import { Collapse, ListGroup } from 'react-bootstrap'
import Arrow from '../../../../assets/icons/arrow-right.svg'
import FormValidators from '../../../../helpers/FormValidators'
import PropTypes from 'prop-types'
import FieldWrapper from '../FieldWrapper'

const SelectField = ({ 
  displayName, 
  placeholder, 
  description, 
  errorMessage, 
  disabled, 
  options, 
  optionsLoading = false, 
  value, 
  onChange,
  floatingOptions = false
}) => {
  const [open, setOpen] = useState(false)
  const [selectedValue, setSelectedValue] = useState(null)

  const onItemSelected = (option) => {
    if (onChange) {
      setSelectedValue(option.value)
      onChange(option.value)
    }
    setOpen(false)
  }

  useEffect(() => {
    // init seletedValue
    setSelectedValue(value)
  }, [value])

  const renderOptions = () => {
    return options?.map((option, i) => {
      return (
        <ListGroup.Item 
          key={`${option.value}-${i}`} 
          className={"select-list-item-container"}
          onClick={() => onItemSelected(option)}
        >
          {option.displayName || option.value}
        </ListGroup.Item>
      )
    })
  }

  const renderLoader = () => {
    return (
      <ListGroup.Item className={"select-list-item-container"}>
        <span>Loading...</span>
      </ListGroup.Item>
    )
  }

  const getSelectValueDisplayName = () => {
    return options?.find(o => o.value === selectedValue)?.displayName ?? selectedValue
  }

  return (
    <FieldWrapper
      displayName={displayName}
      description={description}
      errorMessage={errorMessage}
      disabled={disabled}
    >
      <div className="select-field-container">
        <div className={'select-field-input'} onClick={!disabled ? () => setOpen(!open) : () => {}}>
          {optionsLoading ? "Loading..." : (
            <label>
              {FormValidators.isNullOrEmpty(selectedValue) ? `${placeholder || displayName}` : getSelectValueDisplayName()}
            </label>
          )}
          <object 
            className={open ? 'angle-up-icon' : 'angle-down-icon'} 
            data={Arrow} 
            type="image/svg+xml" 
            aria-label="arrow"
          />
        </div>
        <Collapse 
          in={disabled ? false : open} 
          className={`collapse-content-container ${floatingOptions ? 'floating-options' : ''}`}
        >
          <ListGroup>
            {optionsLoading ? renderLoader() : renderOptions()} 
          </ListGroup>
        </Collapse>
      </div>
    </FieldWrapper>
  )
}

SelectField.propTypes = {
  displayName: PropTypes.string,
  placeholder: PropTypes.string,
  description: PropTypes.string,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  options: PropTypes.array.isRequired,
  optionsLoading: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  floatingOptions: PropTypes.bool
}

export default SelectField
